const fontSets = {
  iconFont: 'IconFont',
  condensedMedium: '"RobotoCondensed-Bold", Arial',
  condenseBold: '"RobotoCondensed-Bold", Arial',
  narrow: '"Roboto-Regular", Arial',
  narrowBold: '"Roboto-Bold", Arial',
  narrowMedium: '"Roboto-Bold", Arial',
  narrowRegular: '"Roboto-Regular", Arial',
};

export default fontSets;
